import { render, staticRenderFns } from "./SalePages.vue?vue&type=template&id=2199ca93&scoped=true&"
import script from "./SalePages.vue?vue&type=script&lang=js&"
export * from "./SalePages.vue?vue&type=script&lang=js&"
import style0 from "./SalePages.vue?vue&type=style&index=0&id=2199ca93&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2199ca93",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VContainer,VIcon,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2199ca93')) {
      api.createRecord('2199ca93', component.options)
    } else {
      api.reload('2199ca93', component.options)
    }
    module.hot.accept("./SalePages.vue?vue&type=template&id=2199ca93&scoped=true&", function () {
      api.rerender('2199ca93', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SalePage/components/SalePages.vue"
export default component.exports